module.exports = __webpack_public_path__ + "media/marine-slider-vid.058dab79.mp4";